import ViewBase from "../../../../framework/core/mvvm/view_base";
import GameUtil from "../../../../utility/game_util";
import SpriteFrameHolder from "../../../public/ui/spriteFrameHolder";
import { privateEncrypt } from "crypto";
import TimeManager from "../../../../manager/time_manager";
import LanguageManager from "../../../../manager/language_manager";
import PrefabsHolder from "../../../public/component/prefabsHolder";
import PublicPlayerAvatar from "../../../public/component/public_player_avatar";
import ModuleManager from "../../../../framework/core/module_manager";
import ModelData from "../../../public/model_data";
import TextureManager from "../../../../manager/texture_manager";
import UserDataManager from "../../../../manager/user_manager";

const { ccclass, property } = cc._decorator;

@ccclass
export default class PlayerSettingChildBaseView extends ViewBase {
    @property(cc.Node)
    itemNode:cc.Node = null

    @property(cc.Node)
    itemGrid:cc.Node = null

    @property(cc.Sprite)
    iconSpr:cc.Sprite = null

    @property(cc.Label)
    timeLab:cc.Label = null

    @property(cc.Label)
    priceLab:cc.Label = null

    @property(cc.Node)
    leftdi:cc.Node = null

    @property(cc.Node)
    leftinfonode:cc.Node = null

    @property(cc.Node)
    pricenode:cc.Node = null

    @property(cc.Node)
    mianfeinode = null

    @property(SpriteFrameHolder)
    spriteAtlas:SpriteFrameHolder = null

    @property(cc.Prefab)
    prefabAtlas:cc.Prefab = null

    @property(PublicPlayerAvatar)
    headsetting:PublicPlayerAvatar = null

    lastShowHeadCode= null

    showLeftInfo(itemData){
        //三个替换 处理可能有些许差异
        let self = this
        this.leftdi.active = itemData.plizedCode == "empty"
        this.leftinfonode.active = itemData.plizedCode != "empty"

        //默认的处理
        if (itemData.plizedCode == "empty"){
            this.leftdi.active =  true
            this.leftinfonode.active = false
        }
        else{
            this.leftdi.active =  false
            this.leftinfonode.active = true

            //免费和非免费处理
            if (itemData.isGoods){
                this.pricenode.active = true
                this.mianfeinode.active = false
                if (itemData.isHave){
                    let timeStr = Math.floor((itemData.endTime/1000) - TimeManager.instance.getServerTime())
                    if (timeStr > 86400){ //是否大于一天的
                        this.timeLab.string = Math.ceil(timeStr / 86400) + "วัน"
                    }
                    else{
                        let str = TimeManager.instance.getTimeLeft2BySecond(timeStr)
                        this.timeLab.string = str
                    }
                }
                else{
                    this.timeLab.string = LanguageManager.t("player_setting_weigoumai")
                }
                let timeStr = Math.floor(itemData.hours/24) 
                let priceStr = GameUtil.currencyFormatting(itemData.goodsVo.discountPrice)
                this.priceLab.string = LanguageManager.t("player_setting_pricetime").format(priceStr,timeStr)
            }
            else{
                this.timeLab.string = LanguageManager.t("player_setting_wuxianzhi")
                this.pricenode.active = false
                this.mianfeinode.active = true
            }
        }


        switch(itemData.plizedType){
            case "head_img":
                this.iconSpr.spriteFrame = this.spriteAtlas.getSpriteFrameByKey(itemData.plizedCode)
                break;
            case "head_frame":
                if (itemData.plizedCode != this.lastShowHeadCode){
                    this.headsetting.loadAnimByKey(itemData.plizedCode)
                    this.lastShowHeadCode = itemData.plizedCode
                }
                break;
            case "card_icon":
                this.iconSpr.spriteFrame = this.spriteAtlas.getSpriteFrameByKey(itemData.plizedCode)
                break;
            default:
                break;
        }
    }
 
}